import { MAX_VSM_KPIS } from "@playbookai/widget-schemas";
import type { ReactElement } from "react";
import { EmptyState } from "../molecules/EmptyState/index.js";
import { CatalogPickerControls } from "./CatalogPickerControls.js";
import { useKpiCatalog } from "./kpi-catalog.js";

/** One selector for KPI cards and tables; the host owns catalogue reads. */
export function KpiPickList({
  selectedId,
  onSelect,
  selectedIds,
  onSelectionChange,
  multiple = false,
}: {
  readonly name: string;
  readonly selectedId?: string | undefined;
  readonly onSelect?: ((kpiId: string) => void) | undefined;
  readonly emptyHint?: string | undefined;
  readonly selectedIds?: readonly string[];
  readonly onSelectionChange?: (ids: string[]) => void;
  readonly multiple?: boolean;
}): ReactElement {
  const catalog = useKpiCatalog();
  if (!catalog)
    return <EmptyState size="sm" title="KPI catalogue unavailable." />;
  return (
    <CatalogPickerControls
      label="KPIs"
      query={catalog.searchQuery}
      isLoading={catalog.isLoading}
      isLoadingMore={catalog.isLoadingMore}
      error={catalog.error}
      hasMore={catalog.hasMore}
      isEmpty={catalog.kpis.length === 0}
      onSearchChange={catalog.onSearchChange}
      onLoadMore={catalog.onLoadMore}
      onRetry={catalog.onRetry}
      items={catalog.kpis.map((kpi) => ({
        id: kpi.id,
        label: kpi.name,
        detail: (
          <>
            {kpi.value}
            {catalog.archivedKpiIds?.includes(kpi.id) ? " · Archived" : ""}
          </>
        ),
      }))}
      selectedIds={
        multiple ? (selectedIds ?? []) : selectedId ? [selectedId] : []
      }
      onSelectionChange={
        multiple ? onSelectionChange : (ids) => onSelect?.(ids[0] ?? "")
      }
      {...(multiple ? { maxSelected: MAX_VSM_KPIS } : {})}
      multiple={multiple}
      bulkSelection={multiple}
    />
  );
}
